var geocoder;

let senators = [],
    formData = {
        'name':'',
        'city':'',
        'state':'',
        'senator1':0,
        'senator2':0,
        'item1':0,
        'item2':0,
        'item3':0,
        'bff':'',
        'favorite':'',
        'poster': 'white', // white, red, black
        'file': ''
    },
    willGallery = {
        'activeSlide': false,
        'initX': 0,
        'currX': 0,
        'will': 0,
        'set': ['white','red','black'],
        'unit': 700
    };

const stateObj = {
    'AL': 'Alabama',
    'AK': 'Alaska',
    'AZ': 'Arizona',
    'AR': 'Arkansas',
    'CA': 'California',
    'CO': 'Colorado',
    'CT': 'Connecticut',
    'DE': 'Delaware',
    'FL': 'Florida',
    'GA': 'Georgia',
    'HI': 'Hawaii',
    'ID': 'Idaho',
    'IL': 'Illinois',
    'IN': 'Indiana',
    'IA': 'Iowa',
    'KS': 'Kansas',
    'KY': 'Kentucky',
    'LA': 'Louisiana',
    'ME': 'Maine',
    'MD': 'Maryland',
    'MA': 'Massachusetts',
    'MI': 'Michigan',
    'MN': 'Minnesota',
    'MS': 'Mississippi',
    'MO': 'Missouri',
    'MT': 'Montana',
    'NE': 'Nebraska',
    'NV': 'Nevada',
    'NH': 'New Hampshire',
    'NJ': 'New Jersey',
    'NM': 'New Mexico',
    'NY': 'New York',
    'NC': 'North Carolina',
    'ND': 'North Dakota',
    'OH': 'Ohio',
    'OK': 'Oklahoma',
    'OR': 'Oregon',
    'PA': 'Pennsylvania',
    'RI': 'Rhode Island',
    'SC': 'South Carolina',
    'SD': 'South Dakota',
    'TN': 'Tennessee',
    'TX': 'Texas',
    'UT': 'Utah',
    'VT': 'Vermont',
    'VA': 'Virginia',
    'WA': 'Washington',
    'WV': 'West Virginia',
    'WI': 'Wisconsin',
    'WY': 'Wyoming'
};

function getAge(dateString) {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}


const isNumberKey = evt => {
    //alert(evt.which);
   var charCode = (evt.which) ? evt.which : event.keyCode
   if (charCode > 31 && (charCode < 48 || charCode > 57)) {
       evt.preventDefault();
       return false;
   }
   return true;
}

function initFormMap(){
    //alert('shout');
}

function populateSenatorSelects(){
    const request = new XMLHttpRequest();
    request.open('GET', '/_assets/data/senators.json');
    request.onreadystatechange = function() {
        if(this.readyState === 4 && this.status === 200) {
            senators = JSON.parse(this.responseText).senators;
            for(i=0; i<senators.length; i++){
                const opt = document.createElement('option');
                opt.value = i;
                //senators[i].shortState + ' - ' +
                let innerHTML = senators[i].firstname + ' ' + senators[i].lastname + ' @';
                innerHTML += (senators[i].instagram != "") ? senators[i].instagram : senators[i].twitter;
                opt.innerHTML = innerHTML;
                const opt2 = opt.cloneNode(true);

                document.getElementById('senator-select-1').appendChild(opt);
                document.getElementById('senator-select-2').appendChild(opt2);
	        }
            //document.getElementById("result").innerHTML = this.responseText;
        }
    };
    request.send();
}

function updateSenators(state){
    let oneset = false;
    for(i=0; i<senators.length; i++){
        if(senators[i].shortState == state){
            if(oneset == false){
                oneset = true;
                document.getElementById('senator-select-1').getElementsByTagName('option')[(i+1)].selected = 'selected';
                document.getElementById('senator-select-1').parentNode.classList.remove('error');
            } else {
                document.getElementById('senator-select-2').getElementsByTagName('option')[(i+1)].selected = 'selected';
                document.getElementById('senator-select-2').parentNode.classList.remove('error');
                return;
            }
        }
	}
}

function wgwMouseDown(e){
    willGallery.initX = e.pageX;
    willGallery.activeSlide = true;
    document.getElementById('will-gallery-strip').classList.add('slide');
}

function wgwMouseMove(e){
    if(willGallery.activeSlide) {
        const x = e.pageX - willGallery.initX + willGallery.currX;
        document.getElementById('will-gallery-strip').style.marginLeft = x + 'px';
    }
}

function wgwMouseUp(e){
    willGallery.activeSlide = false;
    let x = e.pageX - willGallery.initX + willGallery.currX,
        setGallery = Math.round(x/willGallery.unit)*-1;

    if(setGallery < 0) { setGallery = 0; }
    if(setGallery >= willGallery.set.length) { setGallery = (willGallery.set.length - 1); }

    if (willGallery.will != setGallery) {
        document.querySelector('#will-sample-' + (willGallery.will + 1)).classList.remove('active');
        document.querySelector('#will-sample-' + (setGallery + 1)).classList.add('active');
        willGallery.will = setGallery;
        formData.poster = willGallery.set[willGallery.will];

        //alert(formData.file +', '+ formData.poster);
        $.ajax({
           url: '/proc-update.php',
           type: 'post',
           data: {'updateid': formData.file, 'poster': formData.poster},
           success: function(response){ /* alert(response); */ }
        });


        //square-download
        //portrait-download
        document.getElementById('square-download').setAttribute('href', '/page/'+ formData.file +'/'+ formData.poster +'.png');
        document.getElementById('portrait-download').setAttribute('href', '/page/'+ formData.file +'/'+ formData.poster +'-p.png');
    }

    x = (setGallery * willGallery.unit)*-1;
    document.getElementById('will-gallery-strip').classList.remove('slide');
    document.getElementById('will-gallery-strip').style.marginLeft = x + 'px';
    willGallery.currX = x;

}


function createWillFollowUp(){
    //@Senator1 and @Senator2
    //let messageCopy = formData.name + ' @';
    let messageCopy = 'Dear @';
        messageCopy += (senators[formData.senator1].instagram != '') ? senators[formData.senator1].instagram : senators[formData.senator1].twitter;
        messageCopy += ' @';
        messageCopy += (senators[formData.senator2].instagram != '') ? senators[formData.senator2].instagram : senators[formData.senator2].twitter;
        //messageCopy += ' it’s time for a change. Please be my witness to my LastWill testament. Stop gun violence now!';
        messageCopy += ': Please be the witness to #MyLastWill and testament should I be killed by gun violence. I beg you to pass stronger, sensible gun laws so that young people like me can live the full lives we deserve. @team_ENOUGH @changetheref MyLastWill.us';


    document.getElementById('message-to-copy').value = messageCopy;

    document.querySelector('#will-creation-message-customize a').addEventListener('click', function(e){
        const copyText = document.getElementById('message-to-copy');
              copyText.select();
              copyText.setSelectionRange(0, 99999);
        document.execCommand("copy");
        if (window.getSelection) {
            window.getSelection().removeAllRanges();
        }
        document.querySelector('#will-creation-message-customize').className = 'copied';
        setTimeout(function(){
            document.querySelector('#will-creation-message-customize').className = '';
        }, 1500);
        e.preventDefault();
    });


    /*
    document.getElementById('will-submit-follow-up-link').addEventListener('click', function(e){

        document.getElementById('create-your-will').scrollIntoView({ behavior: "smooth", inline: "start" });

        setTimeout(function(){
            const request = new XMLHttpRequest();
            request.open('GET', '/create-your-will/amplify.html');
            request.onreadystatechange = function() {
                if(this.readyState === 4 && this.status === 200) {
                    document.querySelector("main").innerHTML = this.responseText;
                    //setupStayInTouch();
                }
            };
            request.send();
        }, 550);

        e.preventDefault();
    });
    */

    document.getElementById('will-gallery-wrap').addEventListener('mousedown', wgwMouseDown, false);
    window.addEventListener('mousemove', wgwMouseMove, false);
    window.addEventListener('mouseup', wgwMouseUp, false);
}



function createYourWillForm(){
    if (document.getElementById('your-name')) {
        document.getElementById('your-name').addEventListener('input', function(e){
            document.getElementById('display-name').innerHTML = (document.getElementById('your-name').value == '') ? '&nbsp;' : document.getElementById('your-name').value;
        });


        document.getElementById('your-name').addEventListener('focus', function(e){  this.parentNode.classList.remove('error');  });
        document.getElementById('city-name').addEventListener('focus', function(e){  this.parentNode.classList.remove('error');  });
        document.getElementById('input-item-1').addEventListener('focus', function(e){
            document.getElementById('input-item-1').parentNode.classList.remove('error');
            document.getElementById('input-item-2').parentNode.classList.remove('error');
            document.getElementById('input-item-3').parentNode.classList.remove('error');
        });
        document.getElementById('input-item-2').addEventListener('focus', function(e){
            document.getElementById('input-item-1').parentNode.classList.remove('error');
            document.getElementById('input-item-2').parentNode.classList.remove('error');
            document.getElementById('input-item-3').parentNode.classList.remove('error');
        });
        document.getElementById('input-item-3').addEventListener('focus', function(e){
            document.getElementById('input-item-1').parentNode.classList.remove('error');
            document.getElementById('input-item-2').parentNode.classList.remove('error');
            document.getElementById('input-item-3').parentNode.classList.remove('error');
        });
        document.getElementById('input-best-friend').addEventListener('focus', function(e){  this.parentNode.classList.remove('error');  });
        document.getElementById('input-favorite-thing').addEventListener('focus', function(e){  this.parentNode.classList.remove('error');  });

        document.getElementById('input-state').addEventListener('click', function(e){  this.parentNode.classList.remove('error');  });
        document.getElementById('senator-select-1').addEventListener('click', function(e){  this.parentNode.classList.remove('error');  });
        document.getElementById('senator-select-2').addEventListener('click', function(e){  this.parentNode.classList.remove('error');  });

        document.getElementById('input-month').addEventListener('focus', function(e){  this.parentNode.classList.remove('error');  }); // this.parentNode.classList.remove('errorage');
        document.getElementById('input-day').addEventListener('focus', function(e){  this.parentNode.classList.remove('error');  });
        document.getElementById('input-year').addEventListener('focus', function(e){  this.parentNode.classList.remove('error');  });
        document.getElementById('input-month').addEventListener("keypress", isNumberKey);
        document.getElementById('input-day').addEventListener("keypress", isNumberKey);
        document.getElementById('input-year').addEventListener("keypress", isNumberKey);

        let selects = document.querySelectorAll('.sample-options select');
        for(i=0; i < selects.length; i++){
	           selects[i].addEventListener('change', function(e){
                   //if(this.value != ''){}
                   this.parentNode.parentNode.querySelector('input').value = this.value;
               });
	    }


        populateSenatorSelects();

        const radioButtons = document.querySelectorAll('.radio');
        for(i=0; i < radioButtons.length; i++){
            radioButtons[i].addEventListener('click', function(e){
                this.classList.remove('error');
                this.classList.toggle('selected');
                e.preventDefault();
            });
    	}

        document.getElementById('input-state').addEventListener('change', function(e){
            updateSenators(this.value);
        });

        document.getElementById('will-submit-link').addEventListener('click', function(e){
            let formError = false;
            let ageError = false;
            //
            const inputName = document.getElementById('your-name'),
                  inputCity = document.getElementById('city-name'),
                  inputState = document.getElementById('input-state'),
                  inputItem1 = document.getElementById('input-item-1'),
                  inputItem2 = document.getElementById('input-item-2'),
                  inputItem3 = document.getElementById('input-item-3'),
                  inputBFF = document.getElementById('input-best-friend'),
                  inputFavorite = document.getElementById('input-favorite-thing'),
                  inputSenator1 = document.getElementById('senator-select-1'),
                  inputSenator2 = document.getElementById('senator-select-2'),
                  inputMonth = document.getElementById('input-month'),
                  inputDay = document.getElementById('input-day'),
                  inputYear = document.getElementById('input-year'),
                  termsAccept = document.querySelector('#terms-accept a');

                  //ageAccept = document.querySelector('#age-accept a');

            if (inputName.value == '') {
                inputName.parentNode.classList.add('error');
                formError = true;
            }
            if (inputCity.value == '') {
                inputCity.parentNode.classList.add('error');
                formError = true;
            }
            if (inputState.value == '') {
                inputState.parentNode.classList.add('error');
                formError = true;
            }
            if (inputItem1.value == ''  && inputItem2.value == '' && inputItem3.value == '') {
                inputItem1.parentNode.classList.add('error');
                inputItem2.parentNode.classList.add('error');
                inputItem3.parentNode.classList.add('error');
                formError = true;
            }
            if (inputBFF.value == '') {
                inputBFF.parentNode.classList.add('error');
                formError = true;
            }
            if (inputFavorite.value == '') {
                inputFavorite.parentNode.classList.add('error');
                formError = true;
            }
            if (inputSenator1.value == '') {
                inputSenator1.parentNode.classList.add('error');
                formError = true;
            }
            if (inputSenator2.value == '') {
                inputSenator2.parentNode.classList.add('error');
                formError = true;
            }

            if (inputMonth.value == '') {
                inputMonth.parentNode.classList.add('error');
                formError = true;
            }
            if (inputDay.value == '') {
                inputDay.parentNode.classList.add('error');
                formError = true;
            }
            if (inputYear.value == '') {
                inputYear.parentNode.classList.add('error');
                formError = true;
            }

            if( getAge(inputYear.value +'/'+ inputMonth.value +'/'+ inputDay.value) < 16 && formError == false) {

                //alert(getAge(inputYear.value +'/'+ inputMonth.value +'/'+ inputDay.value));
                document.getElementById('age-accept').classList.add('errorage');
                ageError = true;
            }


            if (termsAccept.classList.contains('selected') == false) {
                termsAccept.classList.add('error');
                formError = true;
            }

            /*
            if (ageAccept.classList.contains('selected') == false) {
                ageAccept.classList.add('error');
                formError = true;
            }
            */

            if (formError) {
                document.getElementById('will-creation').scrollIntoView({ behavior: "smooth", inline: "start" });
            } else if (ageError == false) {

                const address = inputCity.value +', '+ stateObj[inputState.value];
                geocoder = new google.maps.Geocoder();
                geocoder.geocode({'address': address}, function(results, status) {
                  if (status === 'OK') {
                      const lat = results[0].geometry.location.lat();
                      const lng = results[0].geometry.location.lng();
                      $.ajax({ url: '/proc-location.php?lat='+ lat +'&lng='+ lng });
                  } else {
                      //alert('Geocode was not successful for the following reason: ' + status);
                  }
                });


                let itemsArr = [];
                let itemsList = '';
                if (inputItem1.value != '') { itemsArr.push(inputItem1.value); }
                if (inputItem2.value != '') { itemsArr.push(inputItem2.value); }
                if (inputItem3.value != '') { itemsArr.push(inputItem3.value); }

                if (itemsArr.length == 1) { itemsList = itemsArr[0]; }
                if (itemsArr.length == 2) { itemsList = itemsArr[0] + ' and ' + itemsArr[1]; }
                if (itemsArr.length == 3) { itemsList = itemsArr[0] + ', ' + itemsArr[1] +', and '+ itemsArr[2]; }

                document.body.scrollIntoView({ behavior: "smooth", inline: "start" });



                formData.name = inputName.value;
                formData.city = inputCity.value;
                formData.state = stateObj[inputState.value];
                formData.senator1 = inputSenator1.value;
                formData.senator1Name = senators[inputSenator1.value].firstname + ' ' + senators[inputSenator1.value].lastname;
                formData.senator2 = inputSenator2.value;
                formData.senator2Name = senators[inputSenator2.value].firstname + ' ' + senators[inputSenator2.value].lastname;
                formData.item1 = inputItem1.value;
                formData.item2 = inputItem2.value;
                formData.item3 = inputItem3.value;
                formData.itemsList = itemsList;
                formData.bff = inputBFF.value;
                formData.favorite = inputFavorite.value;

                $.ajax({
                   url: '/proc.php',
                   type: 'post',
                   data: formData,
                   success: function(response){

                       formData.file =  response;

                       document.getElementById('square-download').setAttribute('href', '/page/'+ response +'/'+ formData.poster +'.png');
                       document.getElementById('portrait-download').setAttribute('href', '/page/'+ response +'/'+ formData.poster +'-p.png');

                       document.querySelector('#will-sample-1 span').setAttribute('style', 'background: transparent url(../page/'+ response +'/white.png) no-repeat center center; background-size: contain;');
                       document.querySelector('#will-sample-2 span').setAttribute('style', 'background: transparent url(../page/'+ response +'/red.png) no-repeat center center; background-size: contain;');
                       document.querySelector('#will-sample-3 span').setAttribute('style', 'background: transparent url(../page/'+ response +'/black.png) no-repeat center center; background-size: contain;');

                       //document.getElementById('link-print-file').setAttribute('href', '/page/'+ formData.file +'/print.html');
                       //document.getElementById('link-print-file').setAttribute('target', '_blank');

                       document.getElementById('link-facebook-share').addEventListener('click',function(e){
                           const loc = window.location.origin +'/page/'+ formData.file;
                           //console.log(wl);
                           //console.log();
                           //console.log(formData.file);
                           window.open(
                               'https://www.facebook.com/sharer/sharer.php?u=' + loc +
                               '& redirect_uri = https: //www.facebook.com'
                           );
                           e.preventDefault();
                       });

                       document.getElementById('link-twitter-share').addEventListener('click',function(e){
                           const loc = window.location.origin +'/page/'+ formData.file;

                           //let messageCopy = formData.name + ' @';
                           let messageCopy = 'Dear @';
                               messageCopy += (senators[formData.senator1].twitter != '') ? senators[formData.senator1].twitter : senators[formData.senator1].instagram;
                               messageCopy += ' @';
                               messageCopy += (senators[formData.senator2].twitter != '') ? senators[formData.senator2].twitter : senators[formData.senator2].instagram;
                               //messageCopy += ' it’s time for a change. Please be my witness to my LastWill testament. Stop gun violence now!';
                               messageCopy += ': Please be the witness to #MyLastWill and testament should I be killed by gun violence. I beg you to pass stronger, sensible gun laws so that young people in America like me can live full lives. @team_ENOUGH @changethref MyLastWill.us';
                               messageCopy += '%0a' + loc;

                           window.open(
                               'https://twitter.com/intent/tweet?text=' +
                               messageCopy +
                               '&amp;source=webclient'
                           );
                           e.preventDefault();
                       });

                   }
                });


                setTimeout(function(){
                    const request = new XMLHttpRequest();
                    request.open('GET', '/create-your-will/thank-you.html');
                    request.onreadystatechange = function() {
                        if(this.readyState === 4 && this.status === 200) {
                            document.querySelector("main").innerHTML = this.responseText;
                            createWillFollowUp();
                        }
                    };
                    request.send();
                }, 550);
            }

            e.preventDefault();
        });

    }
}
